/**
 * Vlazura Free Gift
 * Config is set via the Shopify Theme Editor → Cart → Free Gift Deal.
 * No code changes needed to swap the trigger or gift product.
 */
class VlazuraCartGift {
  constructor(el) {
    this.triggerHandle = el.dataset.giftTrigger;
    this.giftHandle    = el.dataset.giftHandle;
    this.giftVariant   = parseInt(el.dataset.giftVariant, 10);

    if (!this.triggerHandle || !this.giftHandle || !this.giftVariant) return;

    this.busy = false;
    this.syncGift();

    document.addEventListener('cart:updated', () => this.syncGift());
  }

  async fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  hasTrigger(cart) {
    return cart.items.some(i => i.handle === this.triggerHandle);
  }

  hasFreeGift(cart) {
    return cart.items.some(i => i.handle === this.giftHandle);
  }

  async addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: this.giftVariant,
        quantity: 1,
        properties: { _free_gift: 'true' }
      })
    });
  }

  async removeGift(cart) {
    const key = cart.items.find(i => i.handle === this.giftHandle)?.key;
    if (!key) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  async syncGift() {
    if (this.busy) return;
    this.busy = true;
    try {
      const cart    = await this.fetchCart();
      const trigger = this.hasTrigger(cart);
      const gift    = this.hasFreeGift(cart);

      if (trigger && !gift) {
        await this.addGift();
        this.setBanner(true);
        this.reloadCart();
      } else if (!trigger && gift) {
        await this.removeGift(cart);
        this.setBanner(false);
        this.reloadCart();
      } else {
        this.setBanner(trigger && gift);
      }
    } finally {
      this.busy = false;
    }
  }

  setBanner(show) {
    document.querySelectorAll('.vlz-gift-banner').forEach(el => {
      el.style.display = show ? 'flex' : 'none';
    });
  }

  reloadCart() {
    if (window.location.pathname === '/cart') {
      setTimeout(() => window.location.reload(), 350);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('cart-items[data-gift-trigger]');
  if (el) new VlazuraCartGift(el);
});
